import { Injectable } from '@angular/core';
import { LocalStorage } from '@core/services/local-storage/local-storage.service';
import { PendingSessionSelection } from '@core/models/pending-session-selection.model';

const STORAGE_KEY = 'mlnPendingExternalSessionSelection';

@Injectable({
  providedIn: 'root',
})
export class PendingSessionSelectionService {
  constructor(private readonly localStore: LocalStorage) {}

  set(conferenceUuid: string, sessionUuid: string): void {
    this.localStore.store(STORAGE_KEY, { conferenceUuid, sessionUuid });
  }

  consume(conferenceUuid: string): string | null {
    const pending = this.localStore.get<PendingSessionSelection>(STORAGE_KEY);

    if (!pending || pending.conferenceUuid !== conferenceUuid) {
      return null;
    }

    this.localStore.remove(STORAGE_KEY);
    return pending.sessionUuid;
  }

  clear(): void {
    this.localStore.remove(STORAGE_KEY);
  }
}
